var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('device-layout',[(!_vm.isMobileOrTabletDevice && _vm.isLargeDevice)?_c('authorized-desktop'):_c('authorized-mobile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }